import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=b695a0ea&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=b695a0ea&prod&lang=scss"
import style1 from "./Products.vue?vue&type=style&index=1&id=b695a0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b695a0ea",
  null
  
)

export default component.exports